import { createManutencao } from "@/services/locacoes";

export type GaragemManutencaoInput = Parameters<typeof createManutencao>[0];

/**
 * Persistência de manutenção registrada pela Garagem (máquina em pátio).
 *
 * Implementado com **Opção A**: reutiliza `ManutencaoRecord` / `createManutencao`.
 * Para usuários com acesso full, o backend já grava `statusAprovacao: "aprovado"`.
 *
 * TODO (se o responsável preferir Opção B): substituir por entidade/tabela separada
 * para manutenções em pátio, mantendo fluxo do operador independente.
 */
export async function registrarManutencaoGaragem(values: GaragemManutencaoInput): Promise<void> {
  await createManutencao(values);
}
